import { loginByUsername, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: {},
    router: [],
    setting: {
      articlePlatform: []
    },
    roleInfo: null
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    // SET_INTRODUCTION: (state, introduction) => {
    //   state.introduction = introduction
    // },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_LOGNO: (state, logno) => {
      state.logno = logno
    },
    SET_USERID: (state, userid) => {
      state.avatar = userid
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(response => {
          const data = response
          // data.topupfee = response.topupfee
          commit('SET_ROLES', data)
          commit('SET_TOKEN', data.Ticket)
          commit('SET_LOGNO', data.LogNo)
          commit('SET_USERID', data.UserId)
          setToken(data.Ticket)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.roles.RoleId).then(response => {
          console.log('999', response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      // return new Promise(resolve => {
      //   commit('SET_TOKEN', role)
      //   setToken(role)
      //   getUserInfo(role).then(response => {
      //     const data = response.data
      //     commit('SET_ROLES', data.roles)
      //     commit('SET_NAME', data.name)
      //     commit('SET_AVATAR', data.avatar)
      //     commit('SET_INTRODUCTION', data.introduction)
      //     dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
      //     resolve()
      //   })
      // })
    }
  }
}

export default user
